import { render, staticRenderFns } from "./NewFolder.vue?vue&type=template&id=4af672e1&scoped=true&"
import script from "./NewFolder.vue?vue&type=script&lang=js&"
export * from "./NewFolder.vue?vue&type=script&lang=js&"
import style0 from "./NewFolder.vue?vue&type=style&index=0&id=4af672e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af672e1",
  null
  
)

export default component.exports